import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { FormSelectDesktop as Select } from '@alfa-bank/site-form-select/desktop';
import { TextDesktop } from '@alfa-bank/site-text-v2/desktop';

import { OfficeSelection as Component } from '../office-selection';
import type { TOfficeSelection, IDeps } from '../models';

import styles from './styles.css';

export const OfficeSelectionDesktop = createWidget<IDeps, TOfficeSelection>({
    Select,
    Text: TextDesktop,
    styles,
})(Component);
